import { render, staticRenderFns } from "./InvestorImpactsPrefs.vue?vue&type=template&id=4209bfef&scoped=true&"
import script from "./InvestorImpactsPrefs.vue?vue&type=script&lang=js&"
export * from "./InvestorImpactsPrefs.vue?vue&type=script&lang=js&"
import style0 from "./InvestorImpactsPrefs.vue?vue&type=style&index=0&id=4209bfef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4209bfef",
  null
  
)

export default component.exports